<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Body-Text-No-Indent--Body-"><span class="CharOverride-2">Travel makes you speechless, </span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span class="CharOverride-2">then it turns you into a storyteller. </span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-1"><span class="CharOverride-1">—Ibn Battuta,</span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-1"><span class="CharOverride-1">fourteenth-century</span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-1"><span class="CharOverride-1">Moroccan traveler</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FranklinAve-1b.vue?be65cbfc